import React, { createContext, useContext, useEffect, useState } from 'react';
import { baseUrl, tokenHardcoded } from '../constants';
import { IBoughtOnePaymentItem, ISubscription } from '../model';

interface AuthContextType {
  subscriptions?: ISubscription[];
  isAuthenticated: boolean;
  loading: boolean;
  baseCheckoutPath: string;
  boughtOnePaymentItems: IBoughtOnePaymentItem[];
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [subscriptions, setSubscriptions] = useState<ISubscription[]>([]);
  const [boughtOnePaymentItems, setBoughtOnePaymentItems] = useState<IBoughtOnePaymentItem[]>([]);
  const [baseCheckoutPath] = React.useState<string>('/checkout');

  const loadAuthorizedData = async () => {
    console.log('loadAuthorizedData: ');
    if (process.env.NODE_ENV === 'development') {
      console.log('development mode ');

      if(false){
        setSubscriptions([
          {
            "subscription_id": "sub_1RJ9skAoRiRnxiYjonXKfBHl",
            "status": "active",
            "billing_cycle_anchor": 1745916674,
            "cancel_at_period_end": false,
            "cancel_at": null,
            "canceled_at": null,
            "created_at": 1745916674,
            "current_period_end": 1777452674,
            "current_period_start": 1745916674,
            "trial_start": null,
            "trial_end": null,
            "discount": {},
            "plans": [
              {
                "plan_id": "prod_PZNQBFShF9HUPE",
                "display_name": "NFL Pro",
                "price_id": "price_1OkEfZAoRiRnxiYjroVlSnIe",
                "price": "9999",
                "interval": "year"
              }
            ]
          }
        ])
        setIsAuthenticated(true);
        setIsLoading(false);
      }

      // @ts-ignore
      await fetch(`${baseUrl}/subscriptions/`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${tokenHardcoded}`
        }
      })
        .then(res => res.json())
        .then((response) => {
          if (Array.isArray(response)) {
            setSubscriptions(response);
          } else {
            setSubscriptions([]);
          }
          setIsLoading(false)
          setIsAuthenticated(true)
        }).catch(() => {
          setIsLoading(false);
        });
    } else {
      // @ts-ignore
      (window.getAccessToken?.({needRedirectToSignIn: false}) ?? (new Promise((resolve) => {resolve('')}))).then(async accessToken => {
        if (!accessToken) {
          setIsLoading(false);
          // setBaseCheckoutPath(`/sign-up?referrer=${window.location.origin}/checkout`);
          return;
        }
        // @ts-ignore
        await fetch(`${baseUrl}/subscriptions/`, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`
          }
        })
          .then(res => res.json())
          .then((response) => {
            if (Array.isArray(response)) {
              setSubscriptions(response);
            } else {
              setSubscriptions([]);
            }
            setIsAuthenticated(true)
            setIsLoading(false)
          })
          .catch(() => {
            setIsLoading(false);
          })
      }).catch(() => {
        setIsLoading(false);
        // setBaseCheckoutPath(`/sign-up?referrer=${window.location.origin}/checkout`);
      })
    }
  }

  const loadBoughtOneTimeItems = async () => {
    let token;
    if (process.env.NODE_ENV === 'development') {
      token = tokenHardcoded;
    } else {
      // @ts-ignore
      token = await window.getAccessToken?.({needRedirectToSignIn: false}) ?? '';
    }
    await fetch(`${window.baseURL}/subscriptions/one-time-payment/user/items`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    })
      .then(res => res.json())
      .then((response) => {
        if (Array.isArray(response)) {
          setBoughtOnePaymentItems(response);
        } else {
          setBoughtOnePaymentItems([]);
        }
      });
  }

  useEffect(() => {
    loadAuthorizedData();
    loadBoughtOneTimeItems();
  }, []);

  return (<AuthContext.Provider value={{ isAuthenticated, loading: isLoading, subscriptions, baseCheckoutPath, boughtOnePaymentItems }}>
    {children}
  </AuthContext.Provider>);
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

export default AuthContext;
